export const AUTH_MESSAGES = {
  REGISTER_SUCCESS: 'Registracija sėkminga! Patikrinkite el. paštą patvirtinimo nuorodai.',
  LOGIN_SUCCESS: 'Sėkmingai prisijungta!',
  LOGOUT_SUCCESS: 'Sėkmingai atsijungta',
  PASSWORD_CHANGED: 'Slaptažodis sėkmingai pakeistas!',
  PASSWORD_RESET_SENT: 'Slaptažodžio atkūrimo el. laiškas išsiųstas!',
  EMAIL_VERIFIED: 'El. paštas sėkmingai patvirtintas!',
  VERIFICATION_EMAIL_SENT: 'Patvirtinimo el. laiškas sėkmingai išsiųstas!',
  PROFILE_UPDATED: 'Profilis sėkmingai atnaujintas',
  REGISTER_ERROR: 'Klaida registruojantis. Bandykite vėl.',
  LOGIN_ERROR: 'Klaida prisijungiant. Patikrinkite el. paštą ir slaptažodį.',
  PASSWORD_CHANGE_ERROR: 'Klaida keičiant slaptažodį. Bandykite vėl.',
  PASSWORD_RESET_ERROR: 'Klaida siunčiant slaptažodžio atkūrimo el. laišką',
  EMAIL_VERIFICATION_ERROR: 'Klaida patvirtinant el. paštą. Bandykite vėl.',
  VERIFICATION_EMAIL_ERROR: 'Klaida siunčiant patvirtinimo el. laišką. Bandykite vėl.',
  PROFILE_UPDATE_ERROR: 'Klaida atnaujinant profilį',
  SESSION_EXPIRED: 'Jūsų sesija pasibaigė. Prašome prisijungti iš naujo.',
  AUTHENTICATION_REQUIRED: 'Turite būti prisijungę, kad atliktumėte šį veiksmą',
};

export const LIST_MESSAGES = {
  ADDED_TO_FAVORITES: 'Pridėta į mėgstamiausius',
  REMOVED_FROM_FAVORITES: 'Pašalinta iš mėgstamiausių',
  ADD_TO_FAVORITES_ERROR: 'Klaida pridedant į mėgstamiausius',
  REMOVE_FROM_FAVORITES_ERROR: 'Klaida šalinant iš mėgstamiausių',
  ADDED_TO_WATCHLIST: 'Pridėta į žiūrėjimo sąrašą',
  REMOVED_FROM_WATCHLIST: 'Pašalinta iš žiūrėjimo sąrašo',
  ADD_TO_WATCHLIST_ERROR: 'Klaida pridedant į žiūrėjimo sąrašą',
  REMOVE_FROM_WATCHLIST_ERROR: 'Klaida šalinant iš žiūrėjimo sąrašo',
  MARKED_AS_WATCHED: 'Pažymėta kaip peržiūrėta',
  REMOVED_FROM_WATCHED: 'Pašalinta iš peržiūrėtų',
  ADD_TO_WATCHED_ERROR: 'Klaida pažymint kaip peržiūrėtą',
  REMOVE_FROM_WATCHED_ERROR: 'Klaida šalinant iš peržiūrėtų',
  RATING_SAVED: 'Įvertinimas išsaugotas',
  RATING_ERROR: 'Klaida saugant įvertinimą',
  SHARE_IMAGE_GENERATED: 'Vaizdas sugeneruotas!',
  SHARE_IMAGE_ERROR: 'Klaida generuojant vaizdą',
};

export const LOADING_MESSAGES = {
  LOADING: 'Kraunama...',
  LOADING_MOVIES: 'Kraunami filmai...',
  LOADING_TV_SHOWS: 'Kraunami TV serialai...',
  LOADING_DETAILS: 'Kraunama informacija...',
  LOADING_MORE: 'Kraunama daugiau...',
  SEARCHING: 'Ieškoma...',
};

export const ERROR_MESSAGES = {
  GENERIC_ERROR: 'Įvyko klaida. Bandykite vėl.',
  NETWORK_ERROR: 'Tinklo klaida. Patikrinkite interneto ryšį.',
  SERVER_ERROR: 'Serverio klaida. Bandykite vėl vėliau.',
  UNKNOWN_ERROR: 'Nežinoma klaida',
  MOVIE_LOAD_ERROR: 'Klaida kraunant filmo informaciją',
  TV_LOAD_ERROR: 'Klaida kraunant TV serialo informaciją',
  SEARCH_ERROR: 'Klaida ieškant',
  NO_RESULTS: 'Rezultatų nerasta',
  MISSING_DATA: 'Trūksta duomenų',
  INVALID_DATA: 'Neteisingi duomenys',
};

export const UI_LABELS = {
  SAVE: 'Išsaugoti',
  CANCEL: 'Atšaukti',
  CLOSE: 'Uždaryti',
  DELETE: 'Ištrinti',
  EDIT: 'Redaguoti',
  ADD: 'Pridėti',
  REMOVE: 'Pašalinti',
  SEARCH: 'Ieškoti',
  FILTER: 'Filtruoti',
  SORT: 'Rūšiuoti',
  RESET: 'Atstatyti',
  SUBMIT: 'Pateikti',
  CONFIRM: 'Patvirtinti',
  BACK: 'Atgal',
  NEXT: 'Toliau',
  LOADING: 'Kraunama',
  SUCCESS: 'Sėkminga',
  ERROR: 'Klaida',
  WARNING: 'Įspėjimas',
  INFO: 'Informacija',
  ADD_TO_FAVORITES: 'Pridėti į mėgstamiausius',
  REMOVE_FROM_FAVORITES: 'Pašalinti iš mėgstamiausių',
  ADD_TO_WATCHLIST: 'Žiūrėti vėliau',
  REMOVE_FROM_WATCHLIST: 'Pašalinti iš žiūrėjimo sąrašo',
  MARK_AS_WATCHED: 'Pažymėti kaip peržiūrėtą',
  ALREADY_WATCHED: 'Peržiūrėta',
  IN_WATCHLIST: 'Žiūrėjimo sąraše',
  FAVORITE: 'Mėgstamas',
  FAVORITES_TITLE: 'Mėgstamiausi',
  WATCHLIST_TITLE: 'Žiūrėjimo sąrašas',
  WATCHED_TITLE: 'Peržiūrėta',
  MOVIES_TITLE: 'Filmai',
  TV_SHOWS_TITLE: 'TV Serialai',
  SHARE: 'Dalintis',
  SHARE_REVIEW: 'Dalintis apžvalga',
  GENERATE_IMAGE: 'Generuoti vaizdą',
  DOWNLOAD_IMAGE: 'Atsisiųsti vaizdą',
  ADD_REVIEW: 'Pridėti apžvalgą',
  YOUR_REVIEW: 'Jūsų apžvalga',
  WRITE_REVIEW_PLACEHOLDER: 'Parašykite savo nuomonę apie šį filmą/serialą...',
};

export const TOOLTIP_MESSAGES = {
  ADD_TO_FAVORITES: 'Pridėti į mėgstamiausius',
  REMOVE_FROM_FAVORITES: 'Pašalinti iš mėgstamiausių',
  ADD_TO_WATCHLIST: 'Pridėti į žiūrėjimo sąrašą',
  REMOVE_FROM_WATCHLIST: 'Pašalinti iš žiūrėjimo sąrašo',
  MARK_AS_WATCHED: 'Pažymėti kaip peržiūrėtą',
  ALREADY_WATCHED: 'Pažymėta kaip peržiūrėta',
  PLAY_TRAILER: 'Žiūrėti anonsą',
  VIEW_DETAILS: 'Žiūrėti išsamią informaciją',
  SHARE: 'Dalintis',
};

export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'Šis laukas yra privalomas',
  INVALID_EMAIL: 'Neteisingas el. pašto formatas',
  PASSWORD_TOO_SHORT: 'Slaptažodis turi būti bent 8 simbolių ilgio',
  PASSWORD_REQUIREMENTS: 'Slaptažodis turi turėti bent vieną mažąją raidę, didžiąją raidę ir skaičių',
  PASSWORDS_DONT_MATCH: 'Slaptažodžiai nesutampa',
  INVALID_YEAR: 'Neteisingi metai',
  YEAR_RANGE_ERROR: 'Pabaigos metai negali būti ankstesni už pradžios metus',
};

export const CONFIRMATION_MESSAGES = {
  DELETE_ITEM: 'Ar tikrai norite ištrinti šį įrašą?',
  REMOVE_FROM_LIST: 'Ar tikrai norite pašalinti iš sąrašo?',
  LOGOUT_CONFIRM: 'Ar tikrai norite atsijungti?',
  DISCARD_CHANGES: 'Ar tikrai norite atšaukti pakeitimus?',
};

export const CONSOLE_MESSAGES = {
  AUTH_INIT_ERROR: 'Auth initialization error:',
  AUTH_ERROR: 'Auth error:',
  LOGIN_ERROR: 'Login error:',
  LOGOUT_ERROR: 'Logout error:',
  REGISTER_ERROR: 'Register error:',
  FORGOT_PASSWORD_ERROR: 'Forgot password error:',
  RESET_PASSWORD_ERROR: 'Reset password error:',
  CHANGE_PASSWORD_ERROR: 'Change password error:',
  EMAIL_VERIFICATION_ERROR: 'Email verification error:',
  RESEND_VERIFICATION_ERROR: 'Resend verification error:',
  FAILED_RESEND_VERIFICATION: 'Failed to resend verification email:',
  ERROR_RESENDING_EMAIL: 'Error resending verification email:',
  UPDATE_PROFILE_ERROR: 'Update profile error:',
  GET_USER_ERROR: 'Get current user error:',
  GET_USER_STATS_ERROR: 'Get user stats error:',
  ADD_TO_WATCHLIST_ERROR: 'Add to watchlist error:',
  REMOVE_FROM_WATCHLIST_ERROR: 'Remove from watchlist error:',
  ADD_TO_FAVORITES_ERROR: 'Add to favorites error:',
  REMOVE_FROM_FAVORITES_ERROR: 'Remove from favorites error:',
  ADD_TO_WATCHED_ERROR: 'Add to watched error:',
  REMOVE_FROM_WATCHED_ERROR: 'Remove from watched error:',
  RATE_ITEM_ERROR: 'Rate item error:',
  ERROR_TOGGLING_FAVORITE: 'Error toggling favorite:',
  ERROR_TOGGLING_WATCHLIST: 'Error toggling watchlist:',
  ERROR_ADDING_TO_WATCHED: 'Error adding to watched:',
  ERROR_REMOVING_FROM_WATCHED: 'Error removing from watched:',
  ERROR_LOADING_USER_ITEMS: 'Error loading user items:',
  ERROR_REMOVING_ITEM: 'Error removing item:',
  ERROR_FETCHING_DETAILS: 'Error fetching details for',
  ERROR_FETCHING_SEARCH: 'Error fetching search suggestions:',
  ERROR_FETCHING_MOVIE: 'Error fetching movie details:',
  ERROR_FETCHING_TV: 'Klaida kraunant TV serialo informaciją:',
  API_REQUEST_ERROR: 'API Request Error:',
  API_HTTP_ERROR: '❌ ApiService: HTTP Error Response:',
  RATE_LIMITED: 'Rate limited. Retrying after',
  TOKEN_VALIDATION_FAILED: 'Token validation failed during initialization:',
  INITIALIZE_AUTH_ERROR: 'Initialize auth error:',
  ICON_NOT_FOUND: 'Icon "{name}" not found',
  REFRESH_USER_DATA_FAILED: 'Failed to refresh user data after email verification:',
  PROFILE_FETCH_FAILED: 'Failed to fetch complete user profile after login:',
  ERROR_GENERATING_SHARE_IMAGE: 'Error generating share image:',
};

export function formatMessage(template, values = {}) {
  return template.replace(/\{(\w+)\}/g, (match, key) => values[key] || match);
}

export function getMediaTypeMessage(message, mediaType) {
  const typeLabels = {
    movie: 'filmą',
    tv: 'serialą'
  };
  return message.replace('{mediaType}', typeLabels[mediaType] || 'turinį');
}
